import client from "../client";
let lng = localStorage.getItem('lng') ? localStorage.getItem('lng') : 'de';
export default {

    index: () => client.get(`banner/index?lng=` + lng)
}